import { combineReducers } from 'redux';
import { appReducer, State as AppState } from './appReducer';
import { monitoringReducer, State as MonitoringState } from './monitoringReducer';
import { shellReducer, State as ShellState } from './shellReducer';
import { deviceReducer, State as DeviceState } from './deviceReducer';
import { deviceGroupReducer, State as DeviceGroupState } from './deviceGroupReducer';
import { policyReducer, State as PolicyState } from './policyReducer';
import { alarmReducer, State as AlarmState } from './alarmReducer';
import { serverReducer, State as ServerState } from './serverReducer';
import { designerReducer, State as DesignerState } from './designerReducer';
import { timelineReducer, State as TimelineState } from './timelineReducer';
import { reportReducer, State as ReportState } from './reportReducer';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';

export type State = Readonly<{
    alarm: AlarmState;
    app: AppState;
    designer: DesignerState;
    device: DeviceState;
    deviceGroup: DeviceGroupState;
    monitoring: MonitoringState;
    policy: PolicyState;
    report: ReportState;
    router: any; // tslint:disable-line
    server: ServerState;
    shell: ShellState;
    timeline: TimelineState;
}>;

export const makeReducer = (history: History) =>
    combineReducers<State>({
        alarm: alarmReducer,
        app: appReducer,
        designer: designerReducer,
        device: deviceReducer,
        deviceGroup: deviceGroupReducer,
        monitoring: monitoringReducer,
        policy: policyReducer,
        report: reportReducer,
        router: connectRouter(history),
        server: serverReducer,
        shell: shellReducer,
        timeline: timelineReducer,
    })
;

// For unit tests only
export const reducer = makeReducer({
    length: 0,
    action: 'PUSH',
    location: {
        pathname: '',
        search: '',
        state: null,
        hash: '',
    },
    push(path: any, state?: any) {},
    replace(path: any, state?: any) {},
    go(n: number) {},
    goBack() {},
    goForward() {},
    block(prompt?: any) { return () => {}; },
    listen(listener: any) { return () => {}; },
    createHref(location: any) { return ''; },
});


// WEBPACK FOOTER //
// ./src/reducers/index.ts